// 20250719: xt/chtg converted the react-bootstrap to only bootstrap 5.3.3 
//         this way we can remove/uninstall react-bootstrap completely
import React from 'react'
import { connect } from 'react-redux'
import { showModal, hideModal, updateModalProps } from '../../actions/modal'
import { postUnitRoleAndShiftIncidentAssignment } from '../../actions/reportSummaries'
//import { Modal, ListGroup, ListGroupItem, FormGroup, FormControl, InputGroup } from 'react-bootstrap'
//import { Modal, Form, InputGroup, FormControl, ListGroup } from 'react-bootstrap'; // for v2

const SelectUnitModal = ({
  agency,
  incident,
  units,
  dispatch,
  visible,
  languageCode
}) => {
  const assignedDepartment = incident.assignments[0].assignee.department_id
  const unitsMaster = agency.assignees.units.filter(
    unit => unit.departments.find(
      department => department === assignedDepartment))

  const hide = () => dispatch(hideModal())
  const saveSelection = (assignmentId) => {
    dispatch(hideModal())

    if (agency.assignees.shifts) {
      const shiftModalProps = {
        agency,
        incident,
        unitId: assignmentId,
        reportSchemaId: incident.report_schema_id,
        shifts: agency.assignees.shifts,
        languageCode
      }

      dispatch(showModal('SELECT_SHIFT', shiftModalProps))
    } else {
      dispatch(postUnitRoleAndShiftIncidentAssignment(incident, agency._id, incident.report_schema_id, assignmentId))
    }
  }

  const filterList = (event) => {
    var updatedList = unitsMaster

    updatedList = updatedList.filter((item) => {
      return item.name[languageCode].toLowerCase().search(
        event.target.value.toLowerCase()) !== -1
    })

    dispatch(updateModalProps('units', updatedList))
  }

//   return (
//     <Modal show={visible} onHide={hide} id='unit-modal' dialogClassName='assignment-modal' backdrop>
//       <Modal.Header closeButton closeLabel='Cancel'>
//         <Modal.Title>Select Unit</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form.Group>
//   <InputGroup id="unit-search-input">
//     <InputGroup.Text>
//       <i className="bi bi-search"></i>
//     </InputGroup.Text>
//     <FormControl
//       id="role-search"
//       type="text"
//       placeholder="Search"
//       onChange={filterList}
//     />
//   </InputGroup>
// </Form.Group>

// <ListGroup className="text-medium">
//   {units
//     .filter((unit) =>
//       unit.departments.find((department) => department === assignedDepartment)
//     )
//     .map((unit) => (
//       <ListGroup.Item key={unit._id} onClick={() => saveSelection(unit._id)}>
//         <div className="department-name">{unit.name[languageCode]}</div>
//       </ListGroup.Item>
//     ))}
// </ListGroup>

//       </Modal.Body>
//     </Modal>
//   )


return (
  visible && (
    <>
      <div
        className="modal fade show d-block"
        id="unit-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog assignment-modal" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Select Unit</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Cancel"
                onClick={hide}
              ></button>
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <div className="input-group" id="unit-search-input">
                  <span className="input-group-text">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    id="role-search"
                    className="form-control"
                    placeholder="Search"
                    onChange={filterList}
                  />
                </div>
              </div>

              <ul className="list-group text-medium">
                {units
                  .filter((unit) =>
                    unit.departments.includes(assignedDepartment)
                  )
                  .map((unit) => (
                    <li
                      key={unit._id}
                      className="list-group-item"
                      onClick={() => saveSelection(unit._id)}
                    >
                      <div className="department-name">
                        {unit.name[languageCode]}
                      </div>
                    </li>
                  ))}
              </ul>
            </div>

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  )
);

}

export default connect()(SelectUnitModal)
